

























































import {
  Component,
  Prop,
  Vue,
} from "@/shared/vuepack";
import moment from "moment";
import {
  HsabExpenseByExternalIdRequest,
  HsabExpenseResponse,
  HsabTransactionDetail,
  UnusedDistributionResponse,
} from "@/shared/types";
import Pill from "@/shared/components/ui/Pill.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import HsabTransactionChildRow from "@/shared/components/cash/hsabank/HsabTransactionChildRow.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import HsabExpenseEditModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseEditModal.vue";
import HsabExpenseDetailsModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseDetailsModal.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsabHsaAccountTransactionStore } from "@/employee/store/hsabHsaAccountTransaction";
import DebitCardTransactionModal from "@/employee/components/landing-pages/hsabank/expense/DebitCardTransactionModal.vue";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";

@Component({
  components: {
    DebitCardTransactionModal,
    GenericLoadingSpinner,
    HsabTransactionChildRow,
    Pill,
    CurrencyAmount,
    HsabExpenseEditModal,
    HsabExpenseDetailsModal,
  }
})
export default class HsabTransactionListItem extends Vue {
  notifierStore = useNotifierStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  custodianSettingsStore = useCustodianSettingsStore();
  hsabHsaAccountTransactionStore = useHsabHsaAccountTransactionStore();

  @Prop()
  transaction: HsabTransactionDetail;

  @Prop()
  isNotional: boolean;

  @Prop()
  isLoadingExpenseCheck: boolean;

  isOpen = false;
  expense: HsabExpenseResponse = null;
  unusedDistribution: UnusedDistributionResponse = null;
  thinking = false;
  toggleOpen (): void {
    this.isOpen = !this.isOpen;
  }

  get showStatusPill () {
    return this.isNonPostedHsaTransaction || this.isCancelledTransaction;
  }

  get statusPillText () {
    if (this.isCancelledTransaction) {
      return "Cancelled";
    } else if (this.isNonPostedHsaTransaction) {
      return "Pending";
    }

    return "";
  }

  get isNonPostedHsaTransaction () {
    if (!this.transaction) {
      return false;
    }

    return !this.isNotional && !this.transaction.isPosted;
  }

  get isCancelledTransaction () {
    if (!this.transaction) {
      return false;
    }

    return this.transaction.paymentStatus === "Cancelled";
  }

  get formattedDate (): string {
    const date = this.transaction.isPosted ? this.transaction.postingDate : this.transaction.effectiveDate;
    return moment(date).format("MMM D, YYYY");
  }

  get isCredit () {
    return this.transaction.creditDebitIndicator === "C";
  }

  get isDebit () {
    return this.transaction.creditDebitIndicator === "D";
  }
  get currencyClasses () {
    let result = "text-center pr-0 w-100 font-size-corection";
    if (this.transaction.creditDebitIndicator === "NA" || this.isCancelledTransaction) {
      result = "text-center pr-0 w-100 font-size-corection color-grey";
    } else if (this.isDebit) {
      result = "text-center pr-0 w-100 font-size-corection color-red";
    }
    return [result];
  }
  get showViewExpenseButton () {
    return !this.isLoadingExpenseCheck
        && !this.thinking
        && ((this.hasFlowId && this.hsabHsaAccountTransactionStore.doesFlowIdHaveAssociation(this.transaction.flowId))
            || this.hasClaimNumber);
  }
  get hasFlowId () {
    return this.transaction && this.transaction.flowId;
  }
  get hasClaimNumber () {
    return this.transaction && this.transaction.claimNumber;
  }

  async onViewExpenseClicked () {
    if (this.isNotional) {
      await this.showExpenseModalForNotionalTransaction();
    } else {
      await this.showExpenseModalForHsaTransaction();
    }
  }

  async showExpenseModalForNotionalTransaction () {
    this.thinking = true;
    const request: HsabExpenseByExternalIdRequest = {
      externalReimbursementId: this.hasClaimNumber ? this.transaction.claimNumber : null,
      externalTransactionId: this.hasFlowId ? this.transaction.flowId : null,
    };
    await this.hsabExpenseFormStore.loadExpenseForNotionalTransaction(request, this.transaction.isPosted);
    this.thinking = false;
  }

  async showExpenseModalForHsaTransaction () {
    this.thinking = true;
    await this.hsabExpenseFormStore.loadExpenseForHsaTransaction(this.transaction);
    this.thinking = false;
  }
}
